import React from 'react'
import './footer.css'
import LogoFooter from '../../assets/logo/logoFooter.png'
import IconButton from '../../components/buttons/iconButton'
import { FaGlobeAmericas, FaPhone, FaLinkedin, FaEnvelope, FaSkype } from "react-icons/fa";

export default function Footer({ handleDialogOpen }) {
    return (
        <div id="footer" className="container-fluid">
            <div className="container py-5">
                <div className="row">
                    <div className="col-12 col-md-3 d-flex align-items-center justify-content-center p-md-0 p-5">
                        <img width="100%" src={LogoFooter} alt="Logotipo Oxfield" />
                    </div>

                    <div className="col-6 col-md-3 d-flex align-items-start justify-content-center mt-4 mt-md-0">
                        <div className="w-100">
                            <ul>
                                <li className="titulo"><p>Mapa do Site</p></li>
                                <li><a href="#section1-role">Quem Somos</a></li>
                                <li><a href="#section2-role">Soluções</a></li>
                                <li><a href="#section3-role">Por que a Oxfield</a></li>
                                <li><a href="#cases-role">Cases de Sucesso</a></li>
                                <li><a href="#depoimentos-role">Depoimentos</a></li>
                                <li><a href="#section5-role">Clientes</a></li>
                                <li><button style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'rgba(255,255,255,0.75)', fontSize: 'inherit' }} onClick={() => handleDialogOpen()}>Contato</button></li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-6 col-md-3 d-flex align-items-start justify-content-center mt-4 mt-md-0">
                        <div className="w-100">
                            <ul>
                                <li className="titulo"><p>Sobre a Oxfield</p></li>
                                <li><button style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'rgba(255,255,255,0.75)', fontSize: 'inherit' }} onClick={() => handleDialogOpen()}>Trabalhe conosco</button></li>
                                <li><a href="#section1-role">Minuta de Contrato</a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="col-12 col-md-3 mt-4 mt-md-0">
                        <p className="titulo">Contato</p>
                        <p className="orange d-flex align-items-center justify-content-center justify-content-md-start">
                            <FaPhone className="mr-2" /> (16) 99361-8378
                        </p>
                        <p className="local">
                            Centro Empresarial Pio XII<br />
                            Rua Praça Pio XII, 1184, Sala 4<br />
                            Pradópolis — SP, CEP 14850-000
                        </p>
                        <p className="orange contato">contato@oxfield.com.br</p>
                        <p className="suporte" style={{ color: 'rgba(255,255,255,0.55)', fontSize: '12px' }}>Suporte Técnico</p>
                        <p className="orange suporte">suporte@oxfield.com.br</p>

                        <div className="d-flex justify-content-center justify-content-md-start mt-2">
                            <a target="_blank" rel="noreferrer" href="https://br.linkedin.com/company/lmsistemas">
                                <IconButton color="white" bg="transparent"><FaLinkedin /></IconButton>
                            </a>
                            <a target="_blank" rel="noreferrer" href="mailto:contato@oxfield.com.br">
                                <IconButton color="white" bg="transparent"><FaEnvelope /></IconButton>
                            </a>
                            <a target="_blank" rel="noreferrer" href="skype:bachega48?chat">
                                <IconButton color="white" bg="transparent"><FaSkype /></IconButton>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row footer-fim p-3">
                <div className="col-12 col-md-6 d-flex align-items-center justify-content-md-start justify-content-center">
                    <p className="d-flex align-items-center m-0 p-0">
                        <FaGlobeAmericas className="mr-2" /> Português (Brasil)
                    </p>
                </div>
                <div className="col-12 col-md-6 d-flex align-items-center justify-content-md-end justify-content-center">
                    <p className="m-2 p-0 m-md-0">© 2026 Oxfield Consultoria e Sistemas. Todos os direitos reservados.</p>
                </div>
            </div>
        </div>
    )
}
